/*Copyright (c) 2025 por Tecnologías de Información MALMUR y empresas afiliadas. Todos los derechos reservados.
Este software es información confidencial y propietaria de Copyright (c) 2025 por Tecnologías de Información MALMUR
 y sus afiliadas. ("Información Confidencial"). Usted no puede divulgar dicha Información Confidencial, 
 y solo puede usar dicha Información Confidencial de acuerdo con los términos del acuerdo de licencia que celebró con MALMUR.*/

/*Copyright (c) 2025 by Tecnologías de Información MALMUR and affiliated companies. All Rights Reserved.
This software is confidential and proprietary information of Copyright (c) 2025 by Tecnologías de Información 
MALMUR and its affiliates. ("Confidential Information"). You may not disclose such Confidential Information, 
and may only use such Confidential Information in accordance with the terms of the license agreement you entered 
into with MALMUR.*/



import DoctorFullForm from "components/forms/doctor/DoctorFullForm";
import { CoreAPI_URLs } from "constants/http.const";
import useHttp from "hooks/http.hook";
import { HeaderEnum, ProviderInterface } from "medicalsystem-shared";
import { FC, useEffect, useState } from "react";
import { FormActionType } from "types/form.enum";
import { getNewDoctorDataContent } from "utils/model.utils";

/**
 * Props for the EditDoctorDataContent component.
 * @interface Props
 * @property {ProviderInterface} [selectedDoctor] - The doctor data to edit
 * @property {string} [doctorId] - The ID of the doctor to fetch and edit
 */
interface Props {
  selectedDoctor?: ProviderInterface;
  doctorId?: string;
}

/**
 * Content component for editing doctor information.
 * Displays a form for updating doctor profile data, credentials, and specializations.
 * Can fetch doctor data by ID if not provided directly.
 * @param {Props} props - Component props
 * @returns {React.ReactElement} The edit doctor content component
 */
const EditDoctorDataContent: FC<Props> = ({ selectedDoctor, doctorId }) => {
  const [doctor, setDoctor] = useState<ProviderInterface>(
    selectedDoctor || getNewDoctorDataContent()
  );

  const [_isLoading, _error, sendRequest] = useHttp();

  useEffect(() => {
    if (doctorId) {
      sendRequest(CoreAPI_URLs.PROVIDER_GENERAL_OPERATIONS, onGetDoctorHandler, "GET", undefined, [
        {
          header: HeaderEnum.RESOURCE_ID,
          value: doctorId,
        },
      ]);
    }
  }, [doctorId]);

  const onGetDoctorHandler = (doctor: ProviderInterface) => {
    setDoctor(doctor);
  };

  return <DoctorFullForm model={doctor} action={FormActionType.MODIFY} isModal={false} isDoctor={true} />;
};

export default EditDoctorDataContent;
